import { render, staticRenderFns } from "./DucInfomation.vue?vue&type=template&id=e425d9d0"
import script from "./DucInfomation.vue?vue&type=script&lang=js"
export * from "./DucInfomation.vue?vue&type=script&lang=js"
import style0 from "./DucInfomation.vue?vue&type=style&index=0&id=e425d9d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports